import VueMediaQueryMixin from './mixins/vue-media-query-mixin' // responsive media queries in vue https://github.com/jofftiquez/vue-media-query-mixin
import translationmixin from './mixins/translation'
// import StorePE from './StorePE.js'  // PE Store, state van de app slaan we hier op
import * as directives from './directives' // haal custom directives binnen
import Vuelidate from 'vuelidate'

// import * as components from './components' // haal alle vue components binnen

// import * as util from './util.js'  // de accolades geven aan dat het een named export is, util is de naam van het object wat ik uit util.js haal



// feature detection, als een feature moet worden toegevoegd omdat de browser dit niet ondersteund
// halen we die op via een url, info --> https://polyfill.io
var featuredetection = function (initvuepe) {

  // Create a list of the features this browser needs.
  // Beware of overly simplistic detects!
  var features = []
  if (!('Promise' in window)) { features.push('Promise') }
  if (!('IntersectionObserver' in window)) { features.push('IntersectionObserver') }
  if (!('after' in Element.prototype)) { features.push('Element.prototype.after') }

  // If any features need to be polyfilled, construct
  // a script tag to load the polyfills and append it
  // to the document
  if (features.length) {
    var s = document.createElement('script')
    s.src = 'https://polyfill.io/v2/polyfill.min.js?features=' + features.join(',') + '&flags=gated,always&callback=initvuepe'
    s.async = true
    document.head.appendChild(s)
  } else {
    // inititialiseer es6 zaken voor PE
    initvuepe()
  }
}



 var init = function (components, Vue) {

  // Register directives
  for (var directive in directives) {
    Vue.directive(directive, directives[directive])
  }
  // bootstrap mediaquery mixin init
  Vue.use(VueMediaQueryMixin, { framework: 'bootstrap' })
  Vue.use(translationmixin)  
  Vue.use(Vuelidate)

  // directive for focus
  Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    
    inserted: function (el, binding) {
           // Focus the element           
      if (binding.value === true){
        var savedScrollTop = $(document).scrollTop() // save scroll position
        el.focus()        
        $(document).scrollTop(savedScrollTop) // restore it        
      }
      
    }
  })





  const VuePlugin = {
    install: function (Vue) {
      // if (Vue._bootstrap_vue_installed) {
      //   return
      // }
      // Vue._bootstrap_vue_installed = true
      
      // Register global components
      for (var component in components) {
        Vue.component(component, components[component])        
      }
    }
  }
  Vue.use(VuePlugin)
  //  array met divs die moeten worden omgezet naar Vue instance (startpunt van de vue applicatie)

}

export const settings = {
  debug: true,
  testsession: {
    SES_taalid: 1,
    SES_defaulttaalid: 1,
    SES_profid: 55,
    SES_orgid: 19,
    SES_personid: 10201
  }
}


//  exporteer de hele rateplan
export default {
  init: init,
  featuredetection: featuredetection
}
